<template>
  <span class="required">{{ text }}</span>
</template>

<script>
export default {
  name: 'RequiredLabel',
  props: {
    /** ラベルテキスト */
    text: { type: String, default: '必須' },
  },
}
</script>

<style lang="postcss" scoped>
.required {
  background: var(--pure-red);
  color: var(--white);
  font-size: 11px;
  font-weight: normal;
  padding: 2px 8px;
}
</style>
